<template>
  <div>
    <div v-if="$router.currentRoute.name === 'advanced-ev-chargers'">
      <h1 class="mt-3 text-xs-center">EV Chargers</h1>

      <div class="layout row justify-end align-center pa-2">
        <v-btn color="primary" :to="{ name: 'advanced-ev-chargers-charger', params: { chargerId: '0' } }">
          <v-icon left>fal fa-plus</v-icon>
          Create Charger
        </v-btn>
      </div>

      <v-tabs v-model="activeTab" icons-and-text @change="onTabChanged">
        <v-tabs-slider color="primary" />
        <v-tab ripple>
          List
          <v-icon>fal fa-list</v-icon>
        </v-tab>
        <v-tab ripple>
          Map
          <v-icon>fal fa-map-marked-alt</v-icon>
        </v-tab>
        <v-tab ripple>
          Fleet Charging
          <v-icon>fal fa-bus-alt</v-icon>
        </v-tab>
        <v-tab v-if="isAdmin" ripple>
          Fleet ID Tags
          <v-icon>fal fa-id-card</v-icon>
        </v-tab>
      </v-tabs>

      <div class="ev-chargers-tab-panels">
        <div v-show="isTabActive(0)" class="ev-chargers-tab-panel">
          <v-layout row wrap px-2>
            <v-flex xs12 sm8 md4 pa-2>
              <v-text-field
                v-model="searchKeywords"
                label="Search charge point or location"
                append-icon="fal fa-search"
                clearable
                hide-details
                :loading="apiInProgress"
                @keyup.enter.native="onApplySearch"
                @click:append="onApplySearch"
              />
            </v-flex>
          </v-layout>
          <v-data-table
            :headers="headers"
            :items="records"
            :pagination.sync="pagination"
            :total-items="totalRecords"
            :loading="apiInProgress"
            :rows-per-page-items="[10, 25, 50]"
            @update:pagination="onPagination"
            must-sort
          >
            <template v-slot:items="{ item }">
              <tr class="clickable-row" @click="openRecord(item)">
                <td>{{ item.chargePointId || '-' }}</td>
                <td>{{ item.status || '-' }}</td>
                <td>{{ item.model || '-' }}</td>
                <td>{{ item.locationLabel || '-' }}</td>
                <td>{{ formatDateTime(item.lastSeenAt, item.timezone) }}</td>
                <td>{{ item.hasAuthToken ? 'Set' : 'Not set' }}</td>
                <td class="text-xs-right">
                  <v-btn
                    v-if="canUseEmulator && item.chargePointId"
                    icon
                    small
                    title="Open Emulator Simulator"
                    @click.stop="openEmulatorDialog(item)"
                  >
                    <v-icon small color="primary">fal fa-charging-station</v-icon>
                  </v-btn>
                  <v-btn icon small title="Edit" @click.stop="openRecord(item)">
                    <v-icon small>fal fa-edit</v-icon>
                  </v-btn>
                  <v-btn icon small title="Delete" @click.stop="deleteRecord(item)">
                    <v-icon small color="error">fal fa-trash</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>

        <div v-show="isTabActive(1)" class="ev-chargers-tab-panel">
          <v-card flat class="pa-2">
            <v-layout row wrap>
              <v-flex xs12 sm8 md4 pa-2>
                <v-text-field
                  v-model="searchKeywords"
                  label="Search charge point or location"
                  append-icon="fal fa-search"
                  clearable
                  hide-details
                  :loading="mapApiInProgress"
                  @keyup.enter.native="onApplySearch"
                  @click:append="onApplySearch"
                />
              </v-flex>
            </v-layout>
            <st-map
              v-if="stMapApis && mapShouldRender"
              disable-search
              disable-map-hash
              container-id="evChargersMap"
              height="70vh"
              :mapbox-access-token="mapboxAccessToken"
              :maptiler-key="maptilerKey"
              :api="stMapApis"
              :on-map-loaded="onMapLoaded"
              :on-bounds-changed="onMapBoundsChanged"
            />
          </v-card>
        </div>

        <div v-show="isTabActive(2)" class="ev-chargers-tab-panel">
          <fleet-charging-panel ref="fleetChargingPanel" :signed-in-user="signedInUser" />
        </div>

        <div v-if="isAdmin" v-show="isTabActive(3)" class="ev-chargers-tab-panel">
          <fleet-id-tags-panel ref="fleetIdTagsPanel" :signed-in-user="signedInUser" />
        </div>
      </div>
    </div>

    <ocpp-emulator-dialog
      v-model="emulatorDialogVisible"
      :charge-point-id="selectedEmulatorChargePointId"
    />

    <router-view :signed-in-user="signedInUser" />
  </div>
</template>

<script>
import src from './src'

export default src
</script>

<style scoped>
.clickable-row {
  cursor: pointer;
}

.clickable-row:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

.ev-chargers-tab-panel {
  width: 100%;
}
</style>
